import { APP_NAME } from "@/lib/brand";

/* Slim one-line footer. The module shortcut tiles were removed: the top bar already carries them. */
export function PageFooter() {
  return (
    <footer
      className="mt-8 flex flex-wrap items-center justify-between gap-2 border-t border-border pt-3 text-[11px] text-muted-foreground"
      data-testid="page-footer"
    >
      <span>{APP_NAME} &middot; ERP Platform</span>
      <span>&copy; {new Date().getFullYear()} Sparkcurv Technologies Pvt Ltd</span>
    </footer>
  );
}
